<script setup>
import { ref, computed, watch } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  totalSteps: {
    type: [Number],
    default: 3,
  },
});

const emit = defineEmits(['finish']);

const store = useStore();

const step = useMapGetter('assistantWizard/currentStep');
const channelConfig = useMapGetter('assistantWizard/getChannelConfig');

const isOnFinalStep = computed(() => step.value === props.totalSteps);
const completedSetup = computed(
  () => Object.keys(channelConfig.value).length !== 0
);

const previous = () => {
  store.dispatch('assistantWizard/previous');
};

const next = () => {
  store.dispatch('assistantWizard/next');
};

const finishWizard = async () => {
  emit('finish');
};

const configuring = computed(
  () => step.value > 0 && step.value < props.totalSteps
);
</script>

<template>
  <section class="flex items-end justify-end p-8">
    <NextButton
      v-if="!isOnFinalStep"
      :label="$t('ASSISTANT_MGMT.WIZARD.SKIP_STEP')"
      class="mr-2"
      md
      slate
      faded
      @click="next"
    />
    <NextButton
      :label="$t('ASSISTANT_MGMT.WIZARD.PREVIOUS_STEP')"
      class="mr-2"
      md
      slate
      faded
      @click="previous"
    />
    <section class="inline-flex">
      <div v-show="configuring">
        <NextButton
          v-show="configuring"
          class="mr-2"
          :label="$t('ASSISTANT_MGMT.WIZARD.NEXT_STEP')"
          @click="next"
        />
      </div>
      <div v-show="isOnFinalStep">
        <NextButton
          class="mr-2"
          :is-disabled="!completedSetup"
          :label="$t('ASSISTANT_MGMT.WIZARD.FINISH')"
          @click="finishWizard"
        />
      </div>
    </section>
  </section>
</template>
